// All displayed add-on prices use this member rate, regardless of booking time.
export const getAddonPrice = (addon) => {
  const price = Number(addon?.price_rate?.member_after_6_or_weekends ?? 0);
  return Number.isFinite(price) ? price : 0;
};
